<template>
  <div>
    <table-view
      ref="tableList"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      @changeTitleActionBtn="handleTitleActionBtn"
      tableCardTitle="ROLE LIST"
      :right-btn-options="{ text: 'Add', isHavePermission: true }"
    >
      <template v-slot:action="{ tableRow }">
        <a
          href="javascript:void (0)"
          class="icon-pencil1"
          style="margin-right: 20px; color: #3a3f63"
          @click="handleEdit(tableRow.row)"
        />
        <el-popconfirm
          title="Confirm to delete？"
          confirm-button-text="confirm"
          cancel-button-text="cancel"
          @confirm="handleRemoveItem(tableRow.row.id)"
        >
          <a
            href="javascript:void(0)"
            class="icon-trash1"
            style="color: #3a3f63"
            slot="reference"
          />
        </el-popconfirm>
      </template>
    </table-view>

    <!-- 新增弹窗   -->
    <el-dialog
      :visible.sync="visible"
      title="Add"
      width="844px"
      @close="handleClose"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <el-card :bordered="false">
        <div class="content-wrapper">
          <div class="form-wrapper">
            <el-form
              :model="form"
              ref="form"
              label-position="top"
              :rules="rules"
            >
              <el-form-item label="Access Role Name" prop="name">
                <el-input style="width: 100%" v-model="form.name" />
              </el-form-item>
              <el-form-item label="Access Role Description" prop="description">
                <el-input style="width: 100%" v-model="form.description" />
              </el-form-item>
              <el-form-item label="BAU & UpliftManual Decision:"></el-form-item>
              <el-form-item
                v-for="item in form.roleManualDecisionBOS"
                :label="'GCR Rating=' + item.gcrRating"
                :key="item.gcrRating"
              >
                <el-row>
                  <el-col :span="10">
                    <el-input style="width: 100%" v-model="item.minAmount">
                      <template slot="append">Million</template>
                    </el-input>
                  </el-col>
                  <el-col :span="4">
                    <p style="text-align: center">to</p>
                  </el-col>
                  <el-col :span="10">
                    <el-input style="width: 100%" v-model="item.maxAmount">
                      <template slot="append">Million</template>
                    </el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item
                label="Extension Manual Decision:"
                prop="minExpiryDay"
              >
                <el-row>
                  <el-col :span="10">
                    <el-input
                      style="width: 100%"
                      v-model="form.minExpiryDay"
                      onkeyup="value=value.replace(/[^\d]/g,'')"
                    >
                      <template slot="append">days</template>
                    </el-input>
                  </el-col>
                  <el-col :span="4">
                    <p style="text-align: center">to</p>
                  </el-col>
                  <el-col :span="10">
                    <el-input
                      style="width: 100%"
                      v-model="form.maxExpiryDay"
                      onkeyup="value=value.replace(/[^\d]/g,'')"
                    >
                      <template slot="append">days</template>
                    </el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </div>
          <div class="tree-wrapper">
            <p class="title">Configuration page</p>
            <div class="tree-content">
              <el-tree
                ref="tree"
                :data="treeData"
                :props="{
                  label: 'name',
                }"
                @check="handleCheck"
                default-expand-all
                show-checkbox
                node-key="id"
                :default-checked-keys="form.permissionIds"
              />
            </div>
          </div>
        </div>
      </el-card>
      <template slot="footer">
        <customize-button style="margin-right: 20px" @click="visible = false">
          Cancel
        </customize-button>
        <customize-button type="primary" @click="handleAddBtn">
          Save
        </customize-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getTableData, removeItem, updateOrAdd } from './api'
import { getMenuList } from '../api'

export default {
  data() {
    const searchModel = [
      {
        label: 'Role Name',
        type: 'input',
        key: 'name',
      },
      {
        label: 'Create Time',
        type: 'time',
        key: 'time',
        defaultValue: [],
      },
    ]
    const tableModel = [
      {
        label: 'Role Name',
        prop: 'name',
      },
      {
        label: 'Role Description',
        prop: 'description',
      },
      {
        label: 'Create Time',
        prop: 'createTime',
      },
      {
        label: 'Action',
        width: 120,
        slotName: 'action',
      },
    ]

    return {
      searchModel: searchModel,
      tableModel: tableModel,
      tableData: [],
      pages: {},
      visible: false,
      form: {
        name: '',
        description: '',
        minExpiryDay: '',
        maxExpiryDay: '',
        permissionIds: [],
        roleManualDecisionBOS: [],
      },
      rules: {
        description: [
          { required: true, trigger: 'blur', message: 'Can not be empty!' },
        ],
        name: [
          { required: true, trigger: 'blur', message: 'Can not be empty!' },
        ],
      },
      treeData: [],
    }
  },
  mounted() {
    this.initTable()
    this._getMenuList()
  },
  created() {
    this.initFormRoleManualDecisionBOSList()
  },
  methods: {
    initFormRoleManualDecisionBOSList() {
      for (let i = 1; i <= 7; i++) {
        this.form.roleManualDecisionBOS.push({
          gcrRating: i,
          maxAmount: '',
          minAmount: '',
        })
      }
      this.form.roleManualDecisionBOS.push({
        gcrRating: 'NR',
        maxAmount: '',
        minAmount: '',
      })
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async _getTableData(params) {
      try {
        const { data, page } = await getTableData(params)
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
    handlePageChange(params) {
      this._getTableData(params)
    },
    async handleRemoveItem(id) {
      try {
        await removeItem(id)
        this.$message.success('success')
        this.initTable()
      } catch (err) {
        console.error(err)
      }
    },
    handleClose() {
      this.formId = ''
      this.$refs.form.resetFields()
      this.form.permissionIds = []
      this.form.roleManualDecisionBOS.forEach(item => {
        item.maxAmount = ''
        item.minAmount = ''
      })
      this.form.minExpiryDay = ''
      this.form.maxExpiryDay = ''
    },
    async handleAddBtn() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        if (!this.form.permissionIds.length) {
          return this.$message.warning('Please configuration the right page')
        }
        const submitData = this.$cloneDeep(this.form)
        if (this.formId) submitData.id = this.formId
        await this.handleUpdateOrAdd(submitData)
      }
    },
    async handleUpdateOrAdd(params) {
      try {
        await updateOrAdd(params)
        this.$message.success('success')
        this.initTable()
        this.visible = false
      } catch (err) {
        console.error(err)
      }
    },
    handleTitleActionBtn() {
      this.visible = true
    },
    async _getMenuList() {
      try {
        this.treeData = await getMenuList()
      } catch (err) {
        console.error(err)
      }
    },
    handleEdit(row) {
      this.visible = true
      this.formId = row.id
      this.$nextTick(() => {
        Object.keys(this.form).forEach(
          key => key === 'roleManualDecisionBOS' || (this.form[key] = row[key]),
        )
        this.form.roleManualDecisionBOS.forEach((item, index) => {
          item.minAmount =
            row.roleManualDecisionVOS[index] &&
            row.roleManualDecisionVOS[index].minAmount
          item.maxAmount =
            row.roleManualDecisionVOS[index] &&
            row.roleManualDecisionVOS[index].maxAmount
        })
      })
    },
    handleCheck() {
      this.form.permissionIds = this.$refs.tree
        .getCheckedNodes(true)
        .map(item => item.id)
    },
  },
}
</script>

<style lang="scss" scoped>
.content-wrapper {
  display: flex;

  .form-wrapper {
    width: 350px;
  }

  .tree-wrapper {
    flex: 1;
    margin-left: 34px;
    padding-top: 12px;

    .tree-content {
      width: 100%;
      padding: 10px;
      box-sizing: border-box;
      margin-top: 20px;

      border: 2px solid #dae0f2;
      border-radius: 4px;
    }
  }
}
</style>
